{
  "nl": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Fase wijzigen",
        "reset_columns": "Kolommen herstellen"
      },
      "labels": {
        "columns": "Kolommen",
        "milestone": "Selecteer een nieuwe fase",
        "no_results": "Geen eenheden gevonden"
      }
    }
  }
}
